export default __webpack_public_path__ + "5399feced58f7d431ac53a558e44f9b5.png";